// extracted by mini-css-extract-plugin
export default {"reviewsLink":"_a9ad3a5c"};